/**
 * Backend health status constants.
 * Use these instead of string literals for type safety.
 */
export const HEALTH_STATUS = {
  /** All services are healthy */
  OK: "ok",
} as const;

/**
 * Health status received from the backend SSE endpoint.
 *
 * Note: Backend only sends "ok" when healthy. If unhealthy, nothing is emitted
 * (EMPTY). Frontend detects issues via 15s heartbeat timeout.
 */
export type HealthPayloadStatus = (typeof HEALTH_STATUS)[keyof typeof HEALTH_STATUS];

/**
 * Payload received from the backend health SSE endpoint.
 * Only sent when API is healthy - absence of messages indicates issues.
 */
export type HealthPayload = {
  /** Always "ok" - unhealthy state is detected via missing heartbeats */
  status: HealthPayloadStatus;
  /** ISO timestamp of the health check */
  timestamp: string;
};
